export const featureList = [
  {
    id: "f01",
    title: "《锦岁长安》权谋线复盘：谁才是真正的执棋者",
    category: "剧情解析",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20still%20of%20an%20ornate%20ancient%20chinese%20chess%20board%20with%20carved%20pieces%20on%20a%20dark%20wood%20table%2C%20warm%20amber%20candlelight%20and%20deep%20indigo%20shadows%2C%20artistic%20film%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=720&height=480&seq=feat-01-cover&orientation=landscape",
    summary: "三步一算、五步一局，把每一条线索重新摆回桌上。",
    workId: "w11",
    author: "青崖"
  },
  {
    id: "f02",
    title: "《逆流黎明》时间线全梳理：结局并非宿命",
    category: "剧情解析",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20abstract%20still%20of%20intertwining%20light%20trails%20and%20clock%20fragments%20floating%20in%20dark%20indigo%20space%2C%20warm%20dawn%20amber%20accents%2C%20artistic%20science%20fiction%20film%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=720&height=480&seq=feat-02-cover&orientation=landscape",
    summary: "把倒叙、插叙按时间轴重排，你会发现导演早给了答案。",
    workId: "w03",
    author: "南屿"
  },
  {
    id: "f03",
    title: "沈砚角色弧光解析：从复仇者到守护者",
    category: "角色分析",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20silhouette%20of%20a%20lone%20figure%20standing%20before%20a%20tall%20lit%20window%20in%20a%20dark%20hall%2C%20dramatic%20indigo%20and%20amber%20light%2C%20artistic%20film%20poster%20aesthetic%20with%20subtle%20grain%2C%20moody%20composition%2C%20no%20text&width=720&height=480&seq=feat-03-cover&orientation=landscape",
    summary: "他的每一次选择都在回答同一个问题：力量该为谁所用。",
    workId: "w01",
    author: "沉木"
  },
  {
    id: "f04",
    title: "《深海的信》叙事结构拆解：三个人，三封信",
    category: "剧情解析",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20still%20of%20three%20folded%20letters%20floating%20above%20a%20dark%20ocean%20surface%20with%20moonlight%2C%20indigo%20tones%20with%20warm%20highlight%2C%20artistic%20film%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=720&height=480&seq=feat-04-cover&orientation=landscape",
    summary: "结构本身就是主题：有些话只能隔着海去说。",
    workId: "w13",
    author: "青崖"
  },
  {
    id: "f05",
    title: "《荣耀年代》群像为何难得？每个配角都有自己的战场",
    category: "角色分析",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20still%20of%20an%20empty%20stadium%20at%20dusk%20with%20floodlights%20glowing%20warm%20amber%20against%20a%20deep%20indigo%20sky%2C%20artistic%20sports%20film%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=720&height=480&seq=feat-05-cover&orientation=landscape",
    summary: "主角只有一个，但“想赢”的人有很多个。",
    workId: "w12",
    author: "南屿"
  },
  {
    id: "f06",
    title: "《悬案笔记》E05—E08 关键道具考据",
    category: "细节考据",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20still%20life%20of%20an%20old%20notebook%20and%20a%20magnifier%20on%20a%20dark%20desk%20under%20a%20single%20warm%20lamp%2C%20deep%20indigo%20shadows%2C%20artistic%20mystery%20film%20aesthetic%20with%20subtle%20grain%2C%20no%20people%20no%20text&width=720&height=480&seq=feat-06-cover&orientation=landscape",
    summary: "那本笔记的翻页节奏，其实一直在提示凶手是谁。",
    workId: "w29",
    author: "沉木"
  }
];